module.exports = __webpack_public_path__ + "img/water-flash-fill.acea0c64.svg";